export default [
  {
    path:'/admin/plugin/list',
    name: 'plugin_list',
    component: () => import('@/views/plugin/list'),
    meta:{
      title:'插件市场',
      keepAlive:false
    }
  },
  {
    path:'/admin/plugin/details',
    name: 'plugin_details',
    component: () => import('@/views/plugin/details'),
    meta:{
      title:'插件详情',
      keepAlive:false
    }
  },
  {
    path: '/admin/plugin/order',
    name: 'plugin_order',
    component: () => import('@/views/plugin/order'),
    meta: {
      title: '插件订单',
      keepAlive: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/plugin.js